import { ICommonState } from "../../../shared/interfaces/ICommonState";

export const InitialState:ICommonState={
    isLoading:false,
    errorMessage:"",
    defaultOrgId:"",
    defaultProjectId:"",
    defaultEnvType:"false"
}
